import { type AptosCollectionMetadata, type AptosTokenData, type TokenV2Metadata } from '@app/client/common/structs';

import { type CombinedCollectionMetadata } from '../../types/collections/collection-data';

export function getAptosCollectionMetadata(
    collectionData: Partial<AptosCollectionMetadata> & { metadata: { name: string } },
): CombinedCollectionMetadata {
    const { metadata, current_supply, floor_price, description, collection_id, uri, collection_name } = collectionData;
    return {
        ...collectionData,
        metadata: {
            ...metadata,
            description,
            name: collection_name || '',
            external_url: uri,
        },
        reservoir_id: collection_id,
        tokenCount: Number(current_supply),
        floor_price_wei: floor_price,
        slug: collection_id,
    };
}

export function getAptosTokenMetadata(tokenData: AptosTokenData): TokenV2Metadata {
    const { metadata, token_name, token_data_id, collection_id } = tokenData;
    return {
        ...tokenData,
        collection: collection_id,
        name: token_name || metadata.name,
        rarity: 0,
        rarity_rank: 0,
        slug: collection_id,
        token_id: token_data_id,
        image_url: metadata.image_url,
        animation_url: metadata.animation_url,
        description: metadata.description,
        attributes: metadata.attributes,
    };
}
